<template>
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title">Add Tag(s)</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true"><close-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></close-icon></span>
          </button>
        </div>
        <div class="modal-body">
                 <multiselect
                        id="folderNameField"
                        v-model="userTypes" 
                        :options="userTypesOptions"
                        :multiple="true"
                        track-by="_id"
                        :custom-label="userTypeLabelCallback"
                        :close-on-select="false"
                        :show-no-results="false"
                        deselectLabel =""
                        selectLabel=""
                        selectedLabel=""
                        placeholder="Enter tag name"
                        :hideSelected="false"
                        :showNoOptions="false"
                        @search-change="getusersOnKeyup($event)"
                        @select="userTypeOnSelect($event)"
                        @remove="userTypeOnRemove($event)"
                        style="margin-top: 7px;">
                        <!-- <div slot="tag" slot-scope="option" class="tags-style"><div class="user-name-or-image" :style="style(option.option.name)"><span class="option__desc"><span class="option__title">{{ option.option.name.split("")[0] }}</span></span></div>
                            <div class="user-name-display">{{option.option.name}}</div>
                            <div class="remove-tag"><close-icon v-on:click.native="userTypeOnRemove(remove.option)"></close-icon></div>
                        </div> -->
                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                        <!-- <div class="user-name-or-image" :style="style(scope.option.name)">{{ scope.option.name.split("")[0] }}</div> -->
                        <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                        </div>
                        <span slot="noResult">No results</span>
                        <span slot="noOptions" style="display:none"></span>
                    </multiselect>
              </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="close">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-2" @click.prevent="updateUserGroup()">{{$t('Add')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from 'vue-multiselect';
import {mapActions} from "vuex";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import closeIcon from "../core/InlineCancelField.vue";

export default {
props:["selectedScreenProfileID","selectedTagIds","isEditGroup"],
  data: () => ({
    dialog: true,
    userTypes: [],
    userTypesOptions: [],
    selectedUserIdNameMap:{},
    postData: {},
    show:false,
    selectedIds:[]
  }),
  components:{
    "multiselect":multiselect,
    "close-icon":closeIcon
  },
  methods:{
    style(name){
        let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
    },
    userTypeLabelCallback(option){
      return `${option.name}`
    },
    userTypeOnSelect(option){
      let index = this.userTypesOptions.findIndex(item => item._id == option._id);
        if(index > -1){
            this.userTypesOptions[index].checked = true; 
            this.selectedUserIdNameMap[option._id] = option.name
        }
    },
    userTypeOnRemove(option){
      let index = this.userTypesOptions.findIndex(item => item._id == option._id);
      if(index > -1){
          this.userTypesOptions[index].checked = false; 
      }
    },
    getusersOnKeyup(option){
      let payload = {}
      if(typeof(option) != "undefined" && option.trim().length > 0){
        payload.params = {name:option}
        this.getTagsOnAutocomplete(payload).then((data) => {
          this.removeAlreadySelectedUsers(data["tags"])
        });
      }else if(option.length==0){
          this.removeAlreadySelectedUsers(this.usersList)
      }
    },
     makeCheckBoxSelection(option){
        return this.userTypes.some((op) => op._id === option._id);
    },
    removeAlreadySelectedUsers(usersList){
        let usersInGroup = usersList;
        if(this.selectedIds != undefined && this.selectedIds.length){
            for(let j = 0; j < this.selectedIds.length; j++){
                let temp = this.selectedIds[j];
                    usersInGroup =  usersInGroup.filter(function(el){
                    return el._id != temp;
                });
            }
            this.userTypesOptions =  usersInGroup;
        }else{
            this.userTypesOptions = usersInGroup;
        }
    },
    close(){
        if(typeof(this.selectedIds) == "undefined"){
          this.selectedIds = [];
            this.$emit('close',[],[]);
            return;
          }
          if(this.selectedUserIdNameMap == undefined){
            this.$emit('close', this.selectedIds,[]);
            return;
          }
          this.$emit('close', this.selectedIds,this.selectedUserIdNameMap);
    },
    updateUserGroup() {
      if(this.userTypes == undefined){
        return;
      }
        let temp = []
        if(this.userTypes.length > 0){
            for(let item of this.userTypes){
                temp.push(item._id);
            }
        }
        if(typeof(temp) == "undefined"){
          this.selectedIds = [];
            this.$emit('close',[],this.selectedUserIdNameMap);
            return
          }
          this.selectedIds = temp;
          this.$emit('close', temp,this.selectedUserIdNameMap);
    },
    updateUsersList(){
        let payload={}
        let paramsInfo = {}
        paramsInfo.filter=JSON.stringify(["name"])
        paramsInfo.limit=Constants.usersRecordsLimit;
        payload = {params:paramsInfo}
        this.getTagsOnAutocomplete(payload).then((data) => {
            this.totalPages = data["page_count"];
            this.page = data["page"];
            this.totalTags = data["total_tags"];
            this.perPage = data["tags_per_page"];
            this.usersList = data["tags"];
        });
    },
    ...mapActions("tags", ["getAllTagsFromServer","getTagsOnAutocomplete"]),
    ...mapActions("metadataProfiles",["updateExistingMetadataProfile"]),
    ...mapActions("users", ["getUsersAutoComplitionFromServer","getAllUsersFromServer"]),
    ...mapActions("userGroups", ["updateExistingUserGroup"]),
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          document.getElementById("folderNameField").focus();
          this.userTypesOptions = [];
        })
      }
    }
  },
  created(){
      Object.assign(this.selectedIds, this.selectedTagIds);
      this.updateUsersList();
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #0d0d0d;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$danger-color: #dc3545 !important;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$secondary-border-color: 1px solid #3a3a3a;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #bbb;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem .75rem;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$active-green-icon-color: #00ff3a;
$mutliselect-tag-bg-color:#131313;
$mutliselect-all-tags-bg-color:#161616;
$multiselect-option-highlight-bg-color:#333;
$multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: 227px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $body-background-color !important;
    border: $modal-border;
    .modal-body{
      background: $modal-background;
      padding: 2rem;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:$input-field-and-label-font-size !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $header-background;
    height: 58px;
    .modal-title{
      color:$header-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
    font-size:$input-field-and-label-font-size;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.close-icon:hover{
  background: $multiselect-option-highlight-bg-color;
  border-radius: 20px;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $body-background-color !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.tags-style{
    display: flex;
    border: 1px solid $multiselect-option-highlight-bg-color;
    height: fit-content;
    padding: 5px;
    width: auto;
    border-radius: 11px;
    margin-inline-end:0px 5px;
    .user-name-display{
        line-height: 33px;
        padding-inline-start: 5px;
    }
    .remove-tag{
        line-height: 32px;
        position: relative;
        inset-inline-start:5px;
        svg{
            height:30px !important;
        }
    }
}

::v-deep{
    .multiselect{
        width:87% !important;
    }

    .multiselect__tags{
        border: none !important;
        border-bottom: 1px solid $active-blue !important;
        border-radius: 0px;
        background: $mutliselect-all-tags-bg-color;
    }
    .multiselect__tag{
        border: $border-color;
        padding: 6px 23px 6px 10px;
        border-radius: 13px;
      background-color: $background !important;
    }
    .multiselect__tag-icon{
        line-height: 25px;
       color:$text-color !important;
    }
    .multiselect__option--highlight {
        background: $multiselect-option-highlight-bg-color !important;
    }
    .multiselect__content {
        background: $header-background !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $mutliselect-tag-bg-color;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$options-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:250px;
    }
    .multiselect__option--selected{
        background: $multiselect-option-highlight-bg-color !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $multiselect-option-highlight-bg-color !important;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $header-background !important;
    }
    .multiselect__tags {
        background: $background!important;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
}
</style>